import { EmployeeInterface } from 'store/ducks/employees/types';
import { SelectedReportTypesInterface } from 'store/ducks/companies/types';

/*
 * Action Types
 */
export enum EmployeesSalesTypes {
  LIST_EMPLOYEES_REQUEST = '@employeesSales/LIST_EMPLOYEES_REQUEST',
  LIST_EMPLOYEES_SUCCESS = '@employeesSales/LIST_EMPLOYEES_SUCCESS',
  LIST_EMPLOYEES_FAILURE = '@employeesSales/LIST_EMPLOYEES_FAILURE',

  GET_EMPLOYEE_REQUEST = '@employeesSales/GET_EMPLOYEE_REQUEST',
  GET_EMPLOYEE_SUCCESS = '@employeesSales/GET_EMPLOYEE_SUCCESS',
  GET_EMPLOYEE_FAILURE = '@employeesSales/GET_EMPLOYEE_FAILURE',

  FILTER_EMPLOYEES_REQUEST = '@employeesSales/FILTER_EMPLOYEES_REQUEST',
  FILTER_EMPLOYEES_SUCCESS = '@employeesSales/FILTER_EMPLOYEES_SUCCESS',
  FILTER_EMPLOYEES_FAILURE = '@employeesSales/FILTER_EMPLOYEES_FAILURE',

  GET_EMPLOYEE_SALES_RESUME_REQUEST = '@employeesSales/GET_EMPLOYEE_SALES_RESUME_REQUEST',
  GET_EMPLOYEE_SALES_RESUME_SUCCESS = '@employeesSales/GET_EMPLOYEE_SALES_RESUME_SUCCESS',
  GET_EMPLOYEE_SALES_RESUME_FAILURE = '@employeesSales/GET_EMPLOYEE_SALES_RESUME_FAILURE',

  GET_EMPLOYEE_SALES_TRIP_RESUME_REQUEST = '@employeesSales/GET_EMPLOYEE_SALES_TRIP_RESUME_REQUEST',
  GET_EMPLOYEE_SALES_TRIP_RESUME_SUCCESS = '@employeesSales/GET_EMPLOYEE_SALES_TRIP_RESUME_SUCCESS',
  GET_EMPLOYEE_SALES_TRIP_RESUME_FAILURE = '@employeesSales/GET_EMPLOYEE_SALES_TRIP_RESUME_FAILURE',

  LIST_PAYMENTS_REQUEST = '@employeesSales/LIST_PAYMENTS_REQUEST',
  LIST_PAYMENTS_SUCCESS = '@employeesSales/LIST_PAYMENTS_SUCCESS',
  LIST_PAYMENTS_FAILURE = '@employeesSales/LIST_PAYMENTS_FAILURE',

  LIST_TRANSACTIONS_REQUEST = '@employeesSales/LIST_TRANSACTIONS_REQUEST',
  LIST_TRANSACTIONS_SUCCESS = '@employeesSales/LIST_TRANSACTIONS_SUCCESS',
  LIST_TRANSACTIONS_FAILURE = '@employeesSales/LIST_TRANSACTIONS_FAILURE',

  ADD_PAYMENT_EMPLOYEE_REQUEST = '@employeesSales/ADD_PAYMENT_EMPLOYEE_REQUEST',
  ADD_PAYMENT_EMPLOYEE_SUCCESS = '@employeesSales/ADD_PAYMENT_EMPLOYEE_SUCCESS',
  ADD_PAYMENT_EMPLOYEE_FAILURE = '@employeesSales/ADD_PAYMENT_EMPLOYEE_FAILURE',
}

/*
 * Data types
 */
export interface SalesResumeInterface {
  transactionValue: number;
  transactionCount: number;
  purchaseTransactionValue: number;
  purchaseTransactionCount: number;
  ticketTransactionValue: number;
  ticketTransactionCount: number;
  entryTransactionValue: number;
  entryTransactionCount: number;
  paymentValue: number;
  paymentCount: number;
  lastEmployeePayments: Array<{
    id: string;
    amount: number;
    description: string;
    paymentDate: string;
    usedDate: string;
    createdAt: string;
    updatedAt: string;
    employeeId: string;
    supervisorId: string;
  }>;
}

export interface PaymentInterface {
  id: string;
  amount: number;
  description: string;
  paymentDate: string;
  usedDate: string;
  externalId: string;
  createdAt: string;
  updatedAt: string;
  employeeId: string;
  supervisorId: string;
  sellingPointId: string;
  TransportSupervisor: {
    id: string;
    name: string;
    email: string;
    photoUrl: string;
    createdAt: string;
    updatedAt: string;
  };
}

export interface TrasactionInterface {
  id: string;
  type: number;
  amount: number;
  usedDate: string;
  createdAt: string;
  updatedAt: string;
  entryId: string;
  tokenId: string;
  walletChargeId: string;
  employeeId: string;
  tripId: string;
  returnedTransactionId: string;
  paymentType: string;
  qrcodeType: string;
  deviceModel: string;
}
export interface EmployeeSalesInterface extends EmployeeInterface {
  resume?: SalesResumeInterface;
}

export interface SelectedPaymentTypesInterface
  extends SelectedReportTypesInterface {}

/*
 * State type
 */
export interface EmployeesSalesState {
  readonly employeesList: EmployeeSalesInterface[];
  readonly employeeData: EmployeeSalesInterface;
  readonly paymentsList: any[];
  readonly transactionsList: any[];
  readonly csv: Array<{
    tripDate: string;
    startedAt: string;
    closedAt: string;
    companyName: string;
    employeeRegistry: string;
  }>;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
